<template>
  <div class="askme-root" :class="$layout.isMobile ? 'flex-column' : 'flex-row'">
    <div>
      <h4>Мы проконсультируем вас по оборудованию, расскажем какой GPU и CPU вам лучше подойдёт, поможем расчитать нагрузку на сервер в зависимости от:</h4>
      <ul>
        <li>количества пользователей</li>
        <li>используемого ПО</li>
        <li>поставленной задачи</li>
      </ul>
    </div>
    <div class="flex-row justify-content-center">
      <BorderlessButton class="btn" border="blue" @click="Flip">
        Получить консультацию
      </BorderlessButton>
    </div>
    <Modal v-if="showModal" @close="Flip">
      <AskmeEmbedded/>
    </Modal>
  </div>
</template>

<script>
import AskmeEmbedded from "@/components/AskmeEmbedded";
import BorderlessButton from "@/components/BorderlessButton";
import Modal from "@/components/Modal";

export default {
  components: {
    AskmeEmbedded,
    BorderlessButton,
    Modal,
  },
  data() {
    return {
      showModal: false,
    }
  },
  methods: {
    Flip() {
      this.showModal = !this.showModal;
    },
  },
}
</script>

<style lang="scss">
.askme-root {
  border-radius: 8px;
  background: $bg-color-1;
  gap: 30px;
  max-width: 800px;
  padding: 30px;
  @media (max-width: 360px) {
    padding: 30px 15px;
  }
}
</style>
